var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import * as React from 'react';
import { isSameDay } from 'date-fns';
import { isDayPickerMultiple } from '../../types';
import { SelectMultipleContext } from './SelectMultipleContext';
/** Provides the values for the [[SelectMultipleContext]]. */
export function SelectMultipleProvider(_a) {
    var initialProps = _a.initialProps, children = _a.children;
    var initialSelected;
    var isMultipleMode = false;
    if (isDayPickerMultiple(initialProps)) {
        initialSelected = initialProps.defaultSelected;
        isMultipleMode = true;
    }
    var _b = React.useState(initialSelected || undefined), selectedDays = _b[0], setSelectedDays = _b[1];
    var handleDayClick = function (day, modifiers, e) {
        var _a, _b;
        if (!isDayPickerMultiple(initialProps)) {
            return;
        }
        (_a = initialProps.onDayClick) === null || _a === void 0 ? void 0 : _a.call(initialProps, day, modifiers, e);
        var isMinSelected = Boolean(initialProps.min &&
            modifiers.selected &&
            selectedDays &&
            selectedDays.length === initialProps.min);
        if (isMinSelected) {
            return;
        }
        var isMaxSelected = Boolean(initialProps.max &&
            !modifiers.selected &&
            selectedDays &&
            selectedDays.length === initialProps.max);
        if (isMaxSelected) {
            return;
        }
        var days = selectedDays ? __spreadArrays(selectedDays) : [];
        if (modifiers.selected) {
            var index = days.findIndex(function (selectedDay) {
                return isSameDay(day, selectedDay);
            });
            days.splice(index, 1);
        }
        else {
            days.push(day);
        }
        setSelectedDays(days);
        (_b = initialProps.onSelect) === null || _b === void 0 ? void 0 : _b.call(initialProps, days, day, modifiers, e);
    };
    var modifiers = {
        selected: [],
        disabled: []
    };
    if (selectedDays && isDayPickerMultiple(initialProps)) {
        modifiers.selected = selectedDays;
        modifiers.disabled = [
            function disableDay(day) {
                var isMaxSelected = initialProps.max && selectedDays.length > initialProps.max - 1;
                var isSelected = selectedDays.some(function (selectedDay) {
                    return isSameDay(selectedDay, day);
                });
                return Boolean(isMaxSelected && !isSelected);
            }
        ];
    }
    return (React.createElement(SelectMultipleContext.Provider, { value: {
            selected: selectedDays,
            handleDayClick: handleDayClick,
            modifiers: modifiers,
            isMultipleMode: isMultipleMode
        } }, children));
}
//# sourceMappingURL=SelectMultipleProvider.js.map